var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-error"},[_c('alert'),_c('md-button',{staticClass:"md-primary",on:{"click":_vm.logout}},[_vm._v("Logout")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }